import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import LabeledInput from 'modules/core/components/LabeledInput'
import NumberField from 'modules/core/components/NumberField'
import i18n from 'modules/core/lib/i18n'

import { AnswerQuestion } from 'modules/questionnaires/components/Answer/AnswerQuestion'
import {
  NumberAnswer as AnswerType,
  Question as QuestionType,
} from 'modules/questionnaires/lib/types'

import './index.styles.css'

type Props = {
  question: QuestionType
  answer?: AnswerType | null
  position?: number
  placeholder?: string
  readonly?: boolean
  onChange: (answer: AnswerType) => void
  hasAttemptedSubmit?: boolean
}

export const AnswerNumber: React.FC<Props> = ({
  question,
  answer,
  position,
  placeholder,
  readonly,
  onChange,
  hasAttemptedSubmit = false,
}) => {
  const [value, setValue] = React.useState<number | undefined>(answer?.answerInt)

  const handleOnChange = (newValue?: number) => {
    setValue(newValue)
    onChange({ ...answer, uuid: question.uuid, answerInt: newValue })
  }

  const isMandatoryAndEmpty = question.mandatory && value == null

  return (
    <AnswerQuestion uuid={question.uuid} position={position} title={question.title}>
      <Box
        flexDirection="row"
        background={readonly ? undefined : 'white'}
        className={'AnswerNumber_content'}
      >
        <LabeledInput isLegend mandatory={isMandatoryAndEmpty} readonly={readonly}>
          <Box flexDirection="row">
            <NumberField
              maxDecimals={0}
              placeholder={placeholder}
              value={value}
              onChange={(v) => handleOnChange(v ?? undefined)}
              readonly={readonly}
              error={
                hasAttemptedSubmit && isMandatoryAndEmpty
                  ? i18n.t('performance_process.reviews.answer_evaluation.missing_mandatory_field')
                  : undefined
              }
            />
          </Box>
        </LabeledInput>
      </Box>
    </AnswerQuestion>
  )
}
